<template>
  <multi-selection-tool-button
    icon="edit"
    :disabled="disabled || !canUseTool('update')"
    :selected="selected"
    :tooltip="$t('Edit')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";
import { multiSelectionToolsMixin } from "@/mixins/forms/multipleObjectsSelection/multiSelectionToolsMixin";

export default {
  name: "HomeFormTableToggleEditionModeTool",

  components: { MultiSelectionToolButton },

  mixins: [multiSelectionToolsMixin],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    selected: {
      type: Boolean,
      default: false
    },

    permission: {
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/ToggleEditionMode.vue